import type { ContainerState } from "@codvero/shared";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/cn.ts";

const tone: Record<ContainerState, string> = {
  none: "bg-surface-2 text-fg-muted",
  creating: "bg-warn-soft text-fg",
  running: "bg-success-soft text-success",
  stopped: "bg-surface-2 text-fg-muted",
  error: "bg-danger-soft text-danger",
};

export function StateBadge({ state, className }: { state: ContainerState; className?: string }) {
  const { t } = useTranslation();
  return (
    <span className={cn("inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-xs font-medium", tone[state], className)}>
      <span className={cn("size-1.5 rounded-full", state === "running" ? "bg-success" : state === "error" ? "bg-danger" : state === "creating" ? "bg-warn animate-pulse" : "bg-fg-muted")} />
      {t(`projects.state.${state}`)}
    </span>
  );
}
